import React from 'react';
import { AreaChart, Area, XAxis, ResponsiveContainer, Tooltip } from 'recharts';

const GEOTimeline = ({ data = [], loading = false }) => {
  if (loading) {
    return (
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-4 animate-pulse" role="region" aria-label="Timeline loading">
        <div className="h-12 bg-gray-200 rounded w-full"></div>
      </div>
    );
  }

  if (!data.length) return null;

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 px-5 py-3" role="region" aria-label="AI mentions timeline overview">
      <ResponsiveContainer width="100%" height={50}>
        <AreaChart data={data} margin={{ top: 5, right: 5, left: 5, bottom: 0 }}>
          <defs>
            <linearGradient id="geoTimelineGrad" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#6366F1" stopOpacity={0.15} />
              <stop offset="95%" stopColor="#6366F1" stopOpacity={0.02} />
            </linearGradient>
          </defs>
          <Tooltip
            contentStyle={{ fontSize: '11px', padding: '4px 8px', borderRadius: '6px', border: '1px solid #E5E7EB', boxShadow: '0 2px 4px rgba(0,0,0,0.06)' }}
            labelStyle={{ fontSize: '10px', color: '#9CA3AF', marginBottom: '2px' }}
            formatter={(value) => [`${value} mentions`, '']}
          />
          <XAxis
            dataKey="date"
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 10, fill: '#9CA3AF' }}
            interval="preserveStartEnd"
          />
          <Area
            type="monotone"
            dataKey="mentions"
            stroke="#6366F1"
            strokeWidth={1.5}
            fill="url(#geoTimelineGrad)"
            dot={false}
            activeDot={{ r: 3, fill: '#6366F1', strokeWidth: 2, stroke: '#fff' }}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};

export default GEOTimeline;
